export default {
  projectManagementApi: {
    getDataSourceOptions: '/api/projectManagement/getDataSourceOptions',
    getProjects: 'api/projectManagement/getProjects',
    addProject: 'api/projectManagement/addProject',
    updateProject: 'api/projectManagement/updateProject',

    projectPageList: 'api/projectManagement/projectPageList',
    delProject: 'api/projectManagement/delProject',
    getProjectDataSources: 'api/projectManagement/getProjectDataSources',
    delDatasource: 'api/projectManagement/delDatasource',
    addProjectDataSource: 'api/projectManagement/addProjectDataSource',
    updateProjectDataSource: 'api/projectManagement/updateProjectDataSource',

    saveUserProject: 'api/projectManagement/saveUserProject',

    priceList: 'api/projectPrice/priceList',
    addProjectPrice: 'api/projectPrice/addProjectPrice',
    addProjectPrice: 'api/projectPrice/addProjectPrice',
    updateProjectPrice: 'api/projectPrice/updateProjectPrice',
    delProjectPrice: 'api/projectPrice/delProjectPrice',
  }
}